import React, { useContext, useRef } from 'react'
import TeamGrid, { TeamMember } from './TeamGrid'
import { FormattedMessage } from 'react-intl'
import SectionWithTag, { Side } from '../../../components/SectionWithTag'
import FadeIn from '../../../components/Animation/FadeIn'
import PaddingContext from '../../../utils/PaddingContext'

const leadership: TeamMember[] = [
    {
        name: 'Laurynas Karpus',
        position: 'page.about.team.ceo',
        linkedIn: 'https://www.linkedin.com/in/laurynaskarpus/',
        slug: 'laurynas-2026',
    },
    {
        name: 'Irmantas Rokaitis',
        position: 'page.about.team.cto',
        linkedIn: 'https://www.linkedin.com/in/irmantas-rokaitis-52336b18b/',
        slug: 'irmantas-2026',
    },
    {
        name: 'Linas Zakrys',
        position: 'page.about.team.cso',
        linkedIn: 'https://www.linkedin.com/in/linas-zakrys-b8480b39/',
        slug: 'linas-2026',
    },
    {
        name: 'Matthew Thompson',
        position: 'page.about.team.vp-industrial-biotech',
        linkedIn: 'https://www.linkedin.com/in/matthew-p-thompson/',
        slug: 'matthew-2026',
    },
    {
        name: 'Cindy Chang',
        position: 'page.about.team.vp-biopharma',
        linkedIn: 'https://www.linkedin.com/in/cindy-chang-a22a66a/',
        slug: 'cindy-2026',
    },
    {
        name: 'Hugo Nordström',
        position: 'page.about.team.cfo',
        linkedIn: 'https://www.linkedin.com/in/hugo-nordstr%C3%B6m/',
        slug: 'hugo-2026',
    },
]

// const advisors: TeamMember[] = [
//     {
//         name: 'Rolandas Meškys',
//         linkedIn: 'https://www.linkedin.com/in/rolandas-me%C5%A1kys-5294761a4/',
//         slug: 'rolandas-meskys',
//     },
//     {
//         name: 'David Nunn',
//         linkedIn: 'https://www.linkedin.com/in/dnnunn/',
//         slug: 'david-nunn',
//     },
//     {
//         name: 'Arvydas Janulaitis',
//         linkedIn: 'https://www.linkedin.com/in/arvydas-janulaitis-318a6741/',
//         slug: 'arvydas-janulaitis',
//     },
// ]

const Team = () => {
    const { padding } = useContext(PaddingContext)
    const ref = useRef<HTMLDivElement>(null)

    return (
        <div className='py-12 md:py-30'>
            <SectionWithTag
                tag={{ id: 'page.about.meet.tag', className: 'pr-0' }}
                className=' 3xl:max-w-screen-2xl mx-auto'
                padding={padding}
                side={Side.LEFT}
            >
                <div className='md:w-[520px] py-9 md:pt-0' ref={ref}>
                    <FormattedMessage id='page.about.meet.leadership' tagName='h2' />
                </div>
            </SectionWithTag>
            <FadeIn>
                <div className='side-padding md:pt-20' style={{ ...padding }}>
                    <TeamGrid data={leadership} />
                </div>
            </FadeIn>
        </div>
    )
}

export default Team
